import { render } from "./menu_middle.vue?vue&type=template&id=24693ab8&scoped=true"
import script from "./menu_middle.vue?vue&type=script&lang=js"
export * from "./menu_middle.vue?vue&type=script&lang=js"

import "./menu_middle.vue?vue&type=style&index=0&id=24693ab8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24693ab8"]])

export default __exports__